// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__NjEBe"};